var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntroduce2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_290_2764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8945 25.3812C10.8945 17.0969 17.6103 10.3812 25.8945 10.3812H55.8945C64.1788 10.3812 70.8945 17.0969 70.8945 25.3812V70.3812H25.8945C17.6103 70.3812 10.8945 63.6654 10.8945 55.3812V25.3812Z",
    fill: "#FF8743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0826 27.3721C45.0239 27.325 44.9564 27.2899 44.884 27.269C44.8117 27.2481 44.7359 27.2417 44.6611 27.2502C44.5862 27.2587 44.5138 27.2819 44.448 27.3185C44.3821 27.3551 44.3242 27.4044 44.2775 27.4634L39.0206 34.1011H36.1072L42.4879 26.045C42.7214 25.7501 43.0109 25.5042 43.3398 25.3215C43.6686 25.1388 44.0303 25.023 44.4041 24.9805C44.7779 24.9381 45.1564 24.9699 45.5178 25.0742C45.8792 25.1785 46.2165 25.3531 46.5102 25.5882L52.3884 30.2969C52.9442 30.7422 53.3134 31.3792 53.4237 32.0828C53.534 32.7864 53.3774 33.5059 52.9845 34.0999H49.9992L51.035 32.8985C51.0852 32.8404 51.1231 32.7727 51.1465 32.6996C51.17 32.6265 51.1784 32.5495 51.1714 32.473C51.1643 32.3966 51.142 32.3224 51.1056 32.2548C51.0692 32.1872 51.0196 32.1276 50.9597 32.0796L48.0999 29.7887L44.7103 34.1011H41.8049L46.3161 28.3611L45.0826 27.3721ZM29.473 30.6749C28.5644 30.6749 27.6929 31.0359 27.0504 31.6784C26.4078 32.3209 26.0469 33.1924 26.0469 34.1011V50.6608C26.0469 52.0239 26.5883 53.331 27.5521 54.2948C28.5159 55.2586 29.8231 55.8001 31.1861 55.8001H50.601C51.9641 55.8001 53.2712 55.2586 54.235 54.2948C55.1988 53.331 55.7403 52.0239 55.7403 50.6608V40.3824C55.7403 39.0193 55.1988 37.7122 54.235 36.7484C53.2712 35.7846 51.9641 35.2431 50.601 35.2431H29.473C29.1701 35.2431 28.8797 35.1228 28.6655 34.9086C28.4513 34.6944 28.331 34.4039 28.331 34.1011C28.331 33.7982 28.4513 33.5077 28.6655 33.2935C28.8797 33.0793 29.1701 32.959 29.473 32.959H34.7036L36.5264 30.6749H29.473ZM46.6039 44.3795H50.03C50.3329 44.3795 50.6234 44.4999 50.8376 44.714C51.0518 44.9282 51.1721 45.2187 51.1721 45.5216C51.1721 45.8245 51.0518 46.115 50.8376 46.3292C50.6234 46.5433 50.3329 46.6637 50.03 46.6637H46.6039C46.301 46.6637 46.0105 46.5433 45.7963 46.3292C45.5821 46.115 45.4618 45.8245 45.4618 45.5216C45.4618 45.2187 45.5821 44.9282 45.7963 44.714C46.0105 44.4999 46.301 44.3795 46.6039 44.3795Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_290_2764",
    x: 0.894531,
    y: 0.381165,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 0.82 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_290_2764"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_290_2764",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroduce2);
export default __webpack_public_path__ + "static/media/introduce2.0d2610e5bf984dbadfb383d4976435ef.svg";
export { ForwardRef as ReactComponent };